<template>
  <div class="recaptcha-container">
    <div :id="idRecaptcha" :ref="idRecaptcha"></div>
    <span
      v-if="recaptchaError"
      style="font-size: 14px; margin-top: 10px; color: red"
    >
      Per favore spunta il controllo reCaptcha
    </span>
  </div>
</template>

<script>
import intl from "./intl/intl";

export default {
  name: "recaptchaContainer",
  components: {},
  props: {
    idRecaptcha: {
      type: String,
      default: "recaptcha",
    },
    siteKey: {
      type: String,
      default: process.env.VUE_APP_RECAPTCHA_SITEKEY,
    },
    recaptchaCallback: {
      type: Function,
      default: (value) => {
        return;
      },
    },
  },

  created() {},
  mounted() {
    this.recaptchaWidgetId = grecaptcha.render(this.$refs[this.idRecaptcha], {
      sitekey: this.siteKey,
      callback: this.captchaCallback,
    });
  },

  data: function () {
    return {
      intl: intl,
      recaptchaError: false,
      recaptchaWidgetId: null,
    };
  },
  methods: {
    captchaCallback(value){
      if(value && this.recaptchaError){
        this.recaptchaError = false
      }
      this.props.recaptchaCallback(value)
    },
    async executeRecaptcha() {
      this.recaptchaError = false
      const recaptchaResponse = await grecaptcha.getResponse(this.recaptchaWidgetId);
      if (recaptchaResponse.length === 0) {
        this.recaptchaError = true
      }
      return recaptchaResponse
    },
  },
  computed: {},
  unmounted() {},
};
</script>
